<template>
  <VaLayout v-if="breakpoint.lgUp" class="h-screen">
    <template #left>
      <div class="relative h-full flex items-center justify-center overflow-hidden bg-slate-900" style="width: 40vw">
        <!-- Background with gradient and pattern -->
        <div class="absolute inset-0 bg-gradient-to-br from-primary via-primary/90 to-accent"></div>

        <!-- Decorative elements -->
        <div class="absolute inset-0 overflow-hidden">
          <!-- Floating circles -->
          <div class="absolute -top-20 -left-20 w-80 h-80 bg-white/5 rounded-full blur-3xl"></div>
          <div class="absolute -bottom-32 -right-32 w-96 h-96 bg-accent/20 rounded-full blur-3xl"></div>
          <div class="absolute top-1/3 right-10 w-40 h-40 bg-white/10 rounded-full blur-2xl"></div>

          <!-- Grid pattern -->
          <div
            class="absolute inset-0 opacity-10"
            style="
              background-image: radial-gradient(circle at 1px 1px, white 1px, transparent 0);
              background-size: 40px 40px;
            "
          ></div>
        </div>

        <!-- Content -->
        <RouterLink
          to="/"
          aria-label="Visit homepage"
          class="relative z-10 flex flex-col items-center text-center px-12"
        >
          <NexaconLogo :height="80" />

          <div class="mt-12 max-w-sm">
            <h2 class="text-2xl font-bold text-white mb-4">Welcome to Nexacon</h2>
            <p class="text-white/70 leading-relaxed">
              The world's leading smart device gateway platform with enterprise-grade security for your IoT
              infrastructure.
            </p>
          </div>

          <!-- Feature highlights -->
          <div class="mt-12 space-y-4 text-left">
            <div class="flex items-center gap-3">
              <div class="w-10 h-10 rounded-xl bg-white/10 flex items-center justify-center">
                <span class="material-icons text-white text-lg">security</span>
              </div>
              <span class="text-white/80 text-sm">Enterprise-grade security</span>
            </div>
            <div class="flex items-center gap-3">
              <div class="w-10 h-10 rounded-xl bg-white/10 flex items-center justify-center">
                <span class="material-icons text-white text-lg">devices</span>
              </div>
              <span class="text-white/80 text-sm">Manage billions of devices</span>
            </div>
            <div class="flex items-center gap-3">
              <div class="w-10 h-10 rounded-xl bg-white/10 flex items-center justify-center">
                <span class="material-icons text-white text-lg">speed</span>
              </div>
              <span class="text-white/80 text-sm">Real-time monitoring</span>
            </div>
          </div>
        </RouterLink>
      </div>
    </template>
    <template #content>
      <main
        class="h-full flex items-center justify-center mx-auto max-w-[420px] px-6 bg-[var(--va-background-secondary)]"
      >
        <RouterView />
      </main>
    </template>
  </VaLayout>

  <VaLayout v-else class="h-screen bg-[var(--va-background-secondary)]">
    <template #content>
      <div class="min-h-screen flex flex-col">
        <!-- Mobile header with gradient -->
        <div class="relative py-8 px-6 bg-gradient-to-br from-primary via-primary/90 to-accent">
          <div
            class="absolute inset-0 opacity-10"
            style="
              background-image: radial-gradient(circle at 1px 1px, white 1px, transparent 0);
              background-size: 30px 30px;
            "
          ></div>
          <RouterLink class="relative z-10 flex justify-center" to="/" aria-label="Visit homepage">
            <NexaconLogo :height="60" />
          </RouterLink>
        </div>

        <!-- Content area -->
        <main class="flex-1 flex items-start justify-center px-6 py-8">
          <div class="w-full max-w-[420px]">
            <RouterView />
          </div>
        </main>
      </div>
    </template>
  </VaLayout>
</template>

<script lang="ts" setup>
import { useBreakpoint } from 'vuestic-ui'
import NexaconLogo from '../components/NexaconLogo.vue'

const breakpoint = useBreakpoint()
</script>

<style scoped>
/* Auth layout animations */
</style>
